/**
 * Project-specific task version format:
 * - dot-separated numeric segments (e.g. `1`, `1.2`, `0.15.10`)
 */
const TASK_VERSION_PATTERN = /^\d+(?:\.\d+)*$/;

export function normalizeTaskVersion(value: string): string {
  return value
    .split('.')
    .map((segment) => String(Number(segment)))
    .join('.');
}

export function formatTaskVersion(version: string): string {
  return version;
}

export function parseTaskVersion(value: unknown): string | null {
  if (value === null || value === undefined) return null;
  const text = String(value).trim();
  if (!text) return null;
  if (!TASK_VERSION_PATTERN.test(text)) return null;
  return normalizeTaskVersion(text);
}

/** React-hook-form Select values use `"none"` for unset. */
export function parseVersionFromFormSelect(value: unknown): string | null {
  if (value === undefined || value === null || value === '' || value === 'none') {
    return null;
  }
  return parseTaskVersion(value);
}

export function compareTaskVersions(a: string, b: string): number {
  const aSegments = a.split('.').map((part) => Number(part));
  const bSegments = b.split('.').map((part) => Number(part));
  const max = Math.max(aSegments.length, bSegments.length);
  for (let i = 0; i < max; i += 1) {
    const av = aSegments[i] ?? 0;
    const bv = bSegments[i] ?? 0;
    if (av !== bv) return av - bv;
  }
  return 0;
}
